import script from "./SubTask.vue?vue&type=script&setup=true&lang=js"
export * from "./SubTask.vue?vue&type=script&setup=true&lang=js"

import "./SubTask.vue?vue&type=style&index=0&id=416b644a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416b644a"]])

export default __exports__